import EmployeeSerive from "../../../../services/employees.service";

const Employees = {
	data() {
		return {
			employees: []
		}
	},

	methods: {
		fetchEmployees() {
			EmployeeSerive.search({
				page: 1,
				limit: 10
			}).then(response => {
				this.employees = response.data.items;
			})
		}
	},
	created() {
		this.fetchEmployees();
	}
};
export default Employees;
